import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import { stateListAction, pincodeListAction } from "../../../redux/actions/general-action";
import { regionSearchListAction } from "../../../redux/actions/settings-action";
import { useFormikContext } from "formik";

const StoreShopAddressTab = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();

  const [stateList, setStateList] = useState([]);
  const [regionList, setRegionList] = useState([]);

  const onSuccessRegion = (data) => {
    setRegionList(
      data?.data?.list.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };

  const onErrorRegion = () => {};

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
    dispatch(regionSearchListAction("", onSuccessRegion, onErrorRegion));
  }, []);

  useEffect(() => {
    if (values.shop_pin_code?.length === 6) {
      dispatch(
        pincodeListAction(
          values.shop_pin_code,
          (response) => {
            if (response?.[0]?.Status !== "Error") {
              const postOffice = response?.[0]?.PostOffice?.[0];
              const country = postOffice?.Country ?? "";
              const district = postOffice?.District ?? "";
              setFieldValue("shop_country_region", country.toLowerCase() === "india" ? "india" : country);
              if (district) {
                const match = regionList.find(
                  (r) => r.label?.toLowerCase() === district.toLowerCase()
                );
                if (match) setFieldValue("shop_region", match.value);
              }
            }
          },
          () => {}
        )
      );
    }
  }, [values.shop_pin_code]);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};
  return (
    <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        isDisabled={disabled}
        label="Address "
        placeholder="Enter Address"
        name="shop_address"
        id={"shop_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_area"
        placeholder="Enter Area"
        label="Area"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_landmark"
        placeholder="Enter Landmark"
        label="Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_town_or_village"
        placeholder="Enter Town/Village"
        label="Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_city"
        placeholder="Enter City"
        label="City"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        placeholder={"Select state"}
        options={stateList}
        label={"State"}
        id={"shop_state"}
        name="shop_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      <SelectField
        isDisabled={disabled}
        // isRequired={true}
        placeholder={"Select country"}
        options={countryList}
        label={"Country"}
        id={"shop_country_region"}
        name="shop_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        // isRequired={true}
        placeholder={"Select region"}
        options={regionList}
        label={"Region"}
        id={"shop_region"}
        name="shop_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="shop_pin_code"
        placeholder="Enter Pin Code"
        label="Pin Code"
        labelWidth="8.5rem"
      />
    </div>
  );
};

export default StoreShopAddressTab;

const countryList = [{ label: "India", value: "india" }];